var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowUp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "9.999 9 10.001 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16 20.5v-7.985l2.42 2.342a.52.52 0 0 0 .715 0l.717-.683a.47.47 0 0 0 0-.684l-4.507-4.35a.53.53 0 0 0-.717 0l-4.48 4.323a.465.465 0 0 0 0 .683l.717.684a.52.52 0 0 0 .715 0L14 12.49v8.01a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5"
})));
export default SvgArrowUp;